var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-5"},[_c('h1',[_vm._v("Accounts")]),_c('router-link',{attrs:{"to":"/accounts/login"}},[_vm._v(" Login")]),_vm._v(" /\n    "),_c('router-link',{attrs:{"to":"/accounts/login"}},[_vm._v(" Signup")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }